/**
 * Configuration for jobs in this app.
 */
const jobiqoJobsConfig = require('./../src/jobiqo/config/jobs');
const mergeDeepRight = require('ramda/src/mergeDeepRight');

module.exports = mergeDeepRight(jobiqoJobsConfig, {
  // Insert config here. this will be deep merged with config from jobiqo. Arrays are not deep mergeable
  // so make sure to cover those with [...jobiqoCompanyConfig.public.SOME_KEY_THAT_IS_ARRAY, new_item ]
  public: {
    JOB_PT_ATTACHMENT_ENABLED: true,
    GEO_INFO: {
      radius: {
        defaultValue: 5,
      },
      fixtures: [
        {
          label: 'Neubrandenburg, Deutschland',
          location: { lat: 53.5678292, lng: 13.2779269 },
        },
        {
          label: 'Prenzlau, Deutschland',
          location: { lat: 53.3173433, lng: 13.8633409 },
        },
        {
          label: 'Neustrelitz, Deutschland',
          location: { lat: 53.3601147, lng: 13.0730197 },
        },
        {
          label: 'Templin, Deutschland',
          location: { lat: 53.1168874, lng: 13.4979688 },
        },
        {
          label: 'Anklam, Deutschland',
          location: { lat: 53.8502906, lng: 13.6959731 },
        },
        {
          label: 'Waren (Müritz), Deutschland',
          location: { lat: 53.5161667, lng: 12.6818562 },
        },
      ],
    },
    ANALYTICS: {
      SOURCE_ENABLED: true,
    },
    AI: {
      JOB_DESCRIPTION: {
        enabled: true,
      },
    },
  },
});
